export const getI18nLocalStorageKey = () => {
  const marketPlaceName = window.location.hostname;
  const isAdmin = window.location.pathname.startsWith('/dashboard');
  const storageKey = isAdmin ? `${marketPlaceName}-admin-i18n` : `${marketPlaceName}-public-i18n`;
  return storageKey;
};

export const getI18nLocalStorageValue = () => {
  return localStorage.getItem(getI18nLocalStorageKey());
};